import React, { useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { getRequest } from 'apis/ApiInstence';
import 'react-toastify/dist/ReactToastify.css';

const AddNews = () => {
  
  const navigate = useNavigate();
  const baseUrl = useMemo(() => (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, ''), []);
  const backendBase = useMemo(() => (process.env.REACT_APP_BACKEND || '').replace(/\/+$/, ''), []);
  const thumbnailInputRef = useRef(null);

  const [formData, setFormData] = useState({
    news_title: '',
    description: '',
    category: '',
    state: '',
    language: '',
    youtube_url: '',
    reporter_id: '',
    thumbnail: null
  });

  const [repoters, setRepoters] = useState([]);
  const [repotersLoading, setRepotersLoading] = useState(false);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    return () => {
      if (preview) URL.revokeObjectURL(preview);
    };
  }, [preview]);

  const categories = [
    { value: '/category/desh', label: 'देश' },
    { value: '/category/videsh', label: 'विदेश' },
    { value: '/category/politics', label: 'राजनीति' },
    { value: '/category/cinema', label: 'सिनेमा' },
    { value: '/category/sports', label: 'खेल' },
    { value: '/category/health', label: 'स्वास्थ्य' },
    { value: '/category/dharm', label: 'धर्म' },
    { value: '/category/science-technology', label: 'विज्ञान और प्रौद्योगिकी' },
    { value: '/category/general', label: 'सामान्य' }
  ];
  const [states] = useState([
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
    'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry'
  ]);
  const [languages] = useState(['bundeli', 'hindi']);
  const selectedRepoter = repoters.find((item) => String(item.id) === String(formData.reporter_id));

  useEffect(() => {
    const fetchRepoters = async () => {
      try {
        setRepotersLoading(true);
        const response = await getRequest('repoter');
        setRepoters(Array.isArray(response?.data) ? response.data : []);
      } catch (error) {
        toast.error('Failed to load repoters list');
      } finally {
        setRepotersLoading(false);
      }
    };

    fetchRepoters();
  }, []);

const handleChange = (e) => {
  const { name, type, value, files } = e.target;

  // FILE INPUT HANDLING
  if (type === "file") {
    const file = files && files[0] ? files[0] : null;

    setFormData((prev) => ({
      ...prev,
      [name]: file,
    }));

    // Thumbnail preview handling
    if (name === "thumbnail") {
      setPreview((prevPreview) => {
        // Clean old preview URL to avoid memory leak
        if (prevPreview) {
          URL.revokeObjectURL(prevPreview);
        }

        return file ? URL.createObjectURL(file) : null;
      });
    }

    return;
  }

  // NORMAL INPUT HANDLING
  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    try {
      const payload = new FormData();
      const categoryLabelByValue = categories.reduce((acc, cat) => {
        acc[cat.value] = cat.label;
        return acc;
      }, {});

      payload.append('news_title', formData.news_title.trim());
      if (formData.description?.trim()) {
        payload.append('description', formData.description.trim());
      }
      payload.append('category', categoryLabelByValue[formData.category] || formData.category);

      if (formData.state) {
        payload.append('state', formData.state);
      }
      if (formData.language) {
        payload.append('language', formData.language);
      }
      if (formData.youtube_url) {
        const youtubeUrl = formData.youtube_url.trim();
        if (youtubeUrl) payload.append('youtube_url', youtubeUrl);
      }

      if (!selectedRepoter) {
        toast.error('Please select a reporter');
        setLoading(false);
        return;
      }
      payload.append('reporter_name', selectedRepoter.name);
      
      // Automatically send reporter image name if it exists
      if (selectedRepoter.image) {
        payload.append('reporter_image_name', selectedRepoter.image);
      }

      if (formData.thumbnail) {
        payload.append('thumbnail', formData.thumbnail);
      }

      await axios.post(`${baseUrl}/product`, payload);

      toast.success('✅ News added successfully');

      setFormData({
        news_title: '',
        description: '',
        category: '',
        state: '',
        language: '',
        youtube_url: '',
        reporter_id: '',
        thumbnail: null
      });

      setPreview(null);

      if (thumbnailInputRef.current) {
        thumbnailInputRef.current.value = '';
      }

      navigate('/ournews');
    } catch (error) {
      console.error(error);
      const message = error?.response?.data;
      if (typeof message === 'string' && message.toLowerCase().includes('required fields missing')) {
        toast.error('❌ Failed to add news');
      } else {
        toast.error(message || '❌ Failed to add news');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-4 mt-md-5 ournews-page">
      <div className="mainheadig mx-2 mx-md-4">
        <h4 className="text-white font-weight-bold">Add News</h4>
      </div>

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="row mx-2 mx-md-4">
          <div className="col-12 col-md-6 mt-3 mt-md-4">
            <label className="adminlables" htmlFor="news_title">
              Title
            </label>
            <input
              type="text"
              id="news_title"
              name="news_title"
              className="form-control"
              value={formData.news_title}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-12 col-md-6 mt-3 mt-md-4">
            <label className="adminlables" htmlFor="reporter_id">
              Reporter Name
            </label>
            <select
              id="reporter_id"
              name="reporter_id"
              className="form-control"
              value={formData.reporter_id}
              onChange={handleChange}
              required
            >
              <option value="">{repotersLoading ? 'Loading reporters...' : 'Select Reporter'}</option>
              {repoters.map((repoter) => (
                <option key={repoter.id} value={repoter.id}>
                  {repoter.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12 col-md-6 mt-3 mt-md-4">
            <label className="adminlables" htmlFor="category">
              Category
            </label>
            <select
              id="category"
              name="category"
              className="form-control"
              value={formData.category}
              onChange={handleChange}
              required
            >
              <option value="">Select Category</option>
              {categories.map((cat) => (
                <option key={cat.value} value={cat.value}>
                  {cat.label}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12 col-md-6 mt-3 mt-md-4">
            <label className="adminlables" htmlFor="state">
              State (Optional)
            </label>
            <select id="state" name="state" className="form-control" value={formData.state} onChange={handleChange}>
              <option value="">Select State</option>
              {states.map((s, i) => (
                <option key={i} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12 col-md-6 mt-3 mt-md-4">
            <label className="adminlables" htmlFor="language">
              Language (Optional)
            </label>
            <select id="language" name="language" className="form-control" value={formData.language} onChange={handleChange}>
              <option value="">Select Language</option>
              {languages.map((l, i) => (
                <option key={i} value={l}>
                  {l}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12 mt-3 mt-md-4">
            <label className="adminlables" htmlFor="description">
              Description
            </label>
            <textarea
              id="description"
              name="description"
              className="form-control"
              rows="4"
              value={formData.description}
              onChange={handleChange}
            />
          </div>

          <div className="col-12 col-md-6 mt-3 mt-md-4">
            <label className="adminlables" htmlFor="youtube_url">
              YouTube URL (Optional)
            </label>
            <input
              type="url"
              id="youtube_url"
              name="youtube_url"
              className="form-control"
              value={formData.youtube_url}
              onChange={handleChange}
            />
          </div>

          <div className="col-12 col-md-6 mt-3 mt-md-4">
  <label className="adminlables" htmlFor="thumbnail">
    Thumbnail
  </label>

  <div
    className="drag-drop-wrapper"
    onDragOver={(e) => e.preventDefault()}
    onDragEnter={(e) =>
      e.currentTarget.querySelector(".drag-drop-box").classList.add("drag-active")
    }
    onDragLeave={(e) =>
      e.currentTarget.querySelector(".drag-drop-box").classList.remove("drag-active")
    }
  onDrop={(e) => {
  e.preventDefault();
  const file = e.dataTransfer.files[0];

  if (file) {
    handleChange({
      target: {
        name: "thumbnail",
        type: "file", // ✅ IMPORTANT
        files: [file],
      },
    });
  }

  e.currentTarget
    .querySelector(".drag-drop-box")
    .classList.remove("drag-active");
}}
  >
    <input
      type="file"
      id="thumbnail"
      name="thumbnail"
      accept="image/*"
      className="drag-drop-input"
      onChange={handleChange}
      ref={thumbnailInputRef}
      required
    />

   <div className="drag-drop-box">
  <div className="drag-drop-icon">
  <i className="fa-solid fa-cloud-arrow-up"></i>
</div>
  <div className="drag-drop-text">
    Drag & Drop files here
  </div>

  <div className="drag-drop-or">or</div>

  <div className="drag-drop-btn">
    Browse Files
  </div>
</div>
    {formData.thumbnail && (
  <div className="file-name-preview">
    Selected: {formData.thumbnail.name}
  </div>
)}

  </div>
</div>

        </div>

        {preview && (
          <div className="mx-2 mx-md-4 mt-3">
            <p className="text-white">Thumbnail Preview:</p>
            <img src={preview} alt="preview" width={150} className="rounded img-fluid ournews-preview-img" />
          </div>
        )}

        {selectedRepoter?.image ? (
          <div className="mx-2 mx-md-4 mt-3">
            <p className="text-white">Selected Reporter:</p>
            <div className="d-flex align-items-center flex-wrap" style={{ gap: 12 }}>
              <img
                src={`${backendBase}/uploads/repoters/${selectedRepoter.image}`}
                alt={selectedRepoter.name}
                width={80}
                height={80}
                className="rounded-circle ournews-reporter-preview"
                style={{ objectFit: 'cover' }}
              />
              <span className="text-white">{selectedRepoter.name}</span>
            </div>
          </div>
        ) : null}

        <div className="mt-4 mt-md-5 text-center text-md-right mx-2 mx-md-4">
          <button className="btn btn-lg addbtn" type="submit" disabled={loading}>
            {loading ? 'Adding...' : 'Add News'}
          </button>
        </div>
      </form>

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default AddNews;
